import type { ResourceStoreContext } from '@atlassian/react-resource-router';

export const getSpaRouterContext = ({ tenantContext }: ResourceStoreContext) => ({
	tenantContext,
});
